import {
  createSurveyGroupTerm,
  confirmWomenInfluence,
} from "./survey-services";
export { createSurveyGroupTerm, confirmWomenInfluence };
